import {
    BookingFlowCardGrid,
    BookingFlowSelectableCard,
    bookingFlowSelectableCardStyles,
} from "components/booking-flow";
import useLanguage from "hooks/language";
import { FollowUpType } from "models/appointment";
import { ReactComponent as PhoneIcon } from "../../../../../assets/images/phone.svg";
import { ReactComponent as TimerIcon } from "../../../../../assets/images/timer.svg";

type ServiceSelectV2Props = {
    selectedFollowUp?: FollowUpType;
    onSelectFollowUp: (selectedFollowUp: FollowUpType) => void;
};

export default function ServiceSelectV2({
    selectedFollowUp,
    onSelectFollowUp,
}: ServiceSelectV2Props): JSX.Element {
    const { translations } = useLanguage();
    const t = translations.bookingFlow.consultation;

    return (
        <BookingFlowCardGrid>
            <BookingFlowSelectableCard
                checked={selectedFollowUp === FollowUpType.Express}
                onSelect={() => onSelectFollowUp(FollowUpType.Express)}
                variant="dark"
                icon={<TimerIcon />}
                headline={t.expressOnlineTitle}
            >
                <div
                    style={{
                        display: "flex",
                        gap: 8,
                        marginTop: 10,
                        flexWrap: "wrap",
                    }}
                >
                    <span
                        className={`${bookingFlowSelectableCardStyles.priceChip} ${bookingFlowSelectableCardStyles.priceChipDark}`}
                    >
                        {t.expressResultsChip}
                    </span>
                    <span
                        className={`${bookingFlowSelectableCardStyles.priceChip} ${bookingFlowSelectableCardStyles.priceChipDark}`}
                    >
                        {t.expressPriceChip}
                    </span>
                </div>
                <p className={bookingFlowSelectableCardStyles.bodyTextLeadDark}>
                    {t.expressLead}
                </p>
                <p
                    className={`${bookingFlowSelectableCardStyles.bodyTextDark} ${bookingFlowSelectableCardStyles.bodyTextDarkTightTop}`}
                    dangerouslySetInnerHTML={{ __html: t.expressBody }}
                />
            </BookingFlowSelectableCard>

            <BookingFlowSelectableCard
                checked={selectedFollowUp === FollowUpType.Regular}
                onSelect={() => onSelectFollowUp(FollowUpType.Regular)}
                icon={<PhoneIcon />}
                headline={t.phoneCallTitle}
            >
                <div
                    style={{
                        display: "flex",
                        gap: 8,
                        marginTop: 10,
                        flexWrap: "wrap",
                    }}
                >
                    <span className={bookingFlowSelectableCardStyles.priceChip}>
                        {t.phoneCallResultsChip}
                    </span>
                    <span className={bookingFlowSelectableCardStyles.priceChip}>
                        {t.phoneCallPriceChip}
                    </span>
                </div>
                <p
                    className={bookingFlowSelectableCardStyles.bodyText}
                    dangerouslySetInnerHTML={{ __html: t.phoneCallBody }}
                />
            </BookingFlowSelectableCard>
        </BookingFlowCardGrid>
    );
}
